<template>
  <div>
      <vx-card>
          <div class="clearfix">
            <img :src="item.image" style="max-width: 500px;width:100%;float: left;margin: 0 20px 10px 0;">
            <h2>{{ item.title }}</h2>
            <p class="my-5" style="color:#b3afaf;">{{ item.sub_title }}</p>
            <div v-html="item.description" class="news-body"></div>
          </div>
      </vx-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          item: []
      }
    },
      created() {
          const thisIns = this;

          // eslint-disable-next-line no-undef
          axios.get(apiUrl+'/n/'+this.$route.params.id+'?token=' + token)
              .then(function (response) {

                  let data = response.data;
                  if(data.code === 200){
                      thisIns.item = data.data;
                  }else{
                      if (data.code === 401){
                          window.logout();
                      }
                      thisIns.$vs.notify({
                          title: 'Error',
                          text:  data.message,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                      });
                  }

              });
      },
    computed: {
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
    .ql-align-center{
        text-align: center;
    }
    .news-body img {
        display: inline-block !important;
        max-width: 100%;
    }
</style>
